<template lang="pug">
pr-wrapper.d-flex.flex-column(fs, bg="darken", v-nv:scope="'chromecast'", nv-exit-protect, @nv-exit.native="close", @nv-back.native="close")
  .chomecast-logo.flex-grow-1.d-flex.align-items-center.justify-content-center(v-nv)
    .display-1(
      :class="{ 'text-muted': !state, 'text-danger': state === 'unavailable' || state === 'error', 'text-info': state === 'available', 'text-success': state === 'watch' }"
    )
      i.fa-2x.fi.flaticon-chromecast
  .chromecast.w-100(v-visible="guide")
    pr-wrapper.chromecast-hero.d-flex.align-items-center(bg)
      .content-wrapper
        .content
          pr-text(size="medium", weight="semibold") {{ $t("Google Chromecast") }}<br>
          pr-text(size="medium") {{ $t("Ready to connect!") }}
          pr-text.text-muted.pt-2 {{ $t("Please follow the instructions to use the Chromecast") }}
    pr-wrapper.chromecast-ssid.d-flex.flex-column.justify-content-start.align-items-center(reverse, bg)
      .searching.text-center.pt-5(v-show="!state")
        icon.fa-spin.fa-2x(:icon="'fas spinner'") 
        pr-text.mt-2.mb-1(weight="bold") {{ $t("Please wait...") }}
        pr-text {{  $t("Searching available chromecast's.")  }}
      .error.text-center.pt-5(v-show="state === 'error'")
        icon.fa-2x(:icon="'fas exclamation-triangle'") 
        pr-text.mt-2.mb-1.text-danger(weight="bold") {{ $t("An error has occurred on the Chromecast server.") }}
        pr-text {{ $t("Please contact technical service.") }}
        pr-text(size="small", muted, v-show="error") {{ error }}
      .no-device.text-center.pt-5(v-show="state === 'unavailable'")
        icon.fa-2x(:icon="'fas frown'") 
        pr-text.mt-2.mb-1.text-danger(weight="bold") {{ $t("Sorry, all chromecast devices are used by other guests.") }}
        pr-text.mt-2.mb-1 {{ $t("Please try again later.") }}
      .connected.text-center.text-success.pt-5.mt-4(v-show="state === 'watch'")
        pr-text.mt-2.mb-1(weight="bold") {{  $t("You're connected")  }}
        pr-text(weight="bold") {{ $t("You can continue over your favorite app.") }}
      .available.h-100.w-100(v-show="state === 'available'")
        .ssid.p-4.shadow(style="background: #f1f1f1")
          pr-text {{ $t("Connect to Wi-Fi") }} <b>@{{ ssid || $t("Not available") }}</b>
        .steps.d-flex.align-items-center
          .left-side.flex-grow-1.p-4
            pr-text {{ $t("Go to ") }} <b>{{ link || $t("Not available") }}</b>
            pr-text.mt-1 {{ $t("Enter the code :") }} <b>{{ code || $t("Not available") }}</b>
            hr.w-100.my-3
            pr-text(weight="semibold") {{ $t("Alternatively, just scan QR code") }}
          .right-side.pr-4
            img.qrcode(:src="qrcode", v-show="qrcode")
    pr-wrapper.chromecast-help.d-flex.align-items-end(bg)
      .content-wrapper.row.no-gutters
        .image.col.col-auto
          img(width="230", src="@/assets/images/chromecast_device.png")
        .content.col.d-flex.flex-column.justify-content-center.pl-4
          pr-text.text-muted.mb-2(size="small") {{ $t("Ready to use!") }}
          pr-text {{ $t("Open your favorite application and tap to chromecast icon!") }}
</template>

<script>
export default {
  name: "chromecast-builtin",
  data() {
    return {
      guide: true,
      state: null,
      error: null,
      interval: null,
      ssid: null,
      link: null,
      code: null,
      qrcode: null
    }
  },
  deactivated() {
    this.reset()
    __.api.get.castRemove()
    _$.vue.$off("chromecast", this.checker)
  },
  async activated() {
    _$.vue.$on("chromecast", this.checker)
    _$.nav.changeScope("chromecast")

    this.reset()
    this.checker()
  },
  mounted() {
    _$.nav.sync("chromecast")
    _$.vue.$on("source", () => this.check())
  },
  methods: {
    async checker() {
      const res = await __.api.get.castReservation()

      if (!res) this.state = "error"
      else if (res.error && res.status !== 200) {
        this.state = "error"
        this.error = res.error
      } else if (res.error) this.state = "unavailable"
      else if (res.heartbeat) this.watch()
      else {
        this.state = "available"
        this.ssid = res.ssid
        this.link = res.link
        this.code = res.reserv_code
        this.qrcode = res.qr_code
      }
    },
    async watch() {
      this.state = "watch"
      this.heartbeat()
    },
    heartbeat() {
      this.interval = _$.makeInterval(() => __.api.get.castHeartbeat(), 60000)
    },
    reset() {
      this.guide = true
      this.state = null
      this.error = null
      this.interval = this.interval ? _$.removeInterval(this.interval) : null
    },
    check() {
      if (this._inactive) return
      if (__.source.isPlatformSource()) __.platform.go()
    },
    close() {
      if (__.source.isPlatformSource()) __.platform.go()
    }
  }
}
</script>

<style lang="scss" scoped>
.chromecast {
  display: flex;

  .chromecast-hero {
    flex: 0 0 25%;
    padding: 2rem 3.5rem 2rem 2rem;
  }

  .chromecast-ssid {
    flex: 0 0 35%;
  }
  .chromecast-help {
    padding: 1rem 1rem 0 2rem;
    flex: 0 0 40%;
  }

  .available {
    .ssid {
      position: relative;
      z-index: 1;
    }
    img.qrcode {
      width: 150px;
    }
  }
}
</style>
